/* @flow */
import { BUYER_LIST_FETCH_ARTICLES_DATA } from '../constants/buyerList';
import { FAIL, START, SUCCESS } from '../constants';
import type { TDispatch } from '../types/core';
import { addJavaHeaders } from '../utils';
import { checkStatus, parseJSON } from '../apiUtils';

export const startFetchingArticlesData = () => ({ type: BUYER_LIST_FETCH_ARTICLES_DATA + START });

export const setArticlesData = (articlesData) => ({
	type: BUYER_LIST_FETCH_ARTICLES_DATA + SUCCESS,
	payload: articlesData,
});

export const fetchingArticlesDataError = () => ({ type: BUYER_LIST_FETCH_ARTICLES_DATA + FAIL });

/**
 * Получение списка статей для роута "Тайный покупатель"
 * */
export const getBuyerArticlesData =
	(page: number, count: number) =>
	async (dispatch: TDispatch, getState, { fetch }) => {
		const {
			token: { token = '' } = {},
			city: { cityIds = [] },
		} = getState();

		dispatch(startFetchingArticlesData());

		const contentUrl = '/lexsApi/content/mystery-buyer/list';

		const fetchOptions = {
			method: 'POST',
			...addJavaHeaders(token),
			body: JSON.stringify({ cityIds, page, count }),
		};

		try {
			const { result, data } = await fetch(contentUrl, fetchOptions).then(checkStatus).then(parseJSON);
			const articlesData = result === 'ok' ? data : null;
			dispatch(setArticlesData(articlesData));
		} catch (e) {
			dispatch(fetchingArticlesDataError());
			console.error(e);
		}
	};
